/**
 * ЭТАП 2 — ИЗОЛЯЦИЯ ЗАПРОСОВ SSR.
 *
 * Проблема: per-request состояние (QueryClient и привязка legacyHistory к
 * роутеру) жило в module-level переменных. Один процесс обслуживает запросы
 * ПАРАЛЛЕЛЬНО, поэтому второй запрос перетирал глобал первого — и первый
 * дорендеривался с чужим QueryClient/location. Симптомы прогона 27.08:
 * пустая шапка (скелетоны меню) и пустые списки в SSR-HTML, пустой <title>,
 * массовые hydration-mismatch (сервер отдал одно, клиент отрисовал другое).
 *
 * Решение: AsyncLocalStorage — контекст живёт ровно в рамках одного запроса и
 * протекает через все await'ы рендера. Сам ALS создаётся в СЕРВЕРНОМ входе
 * (src/server.ts) и прокидывается сюда через setRequestScopeImpl, поэтому
 * этот модуль остаётся client-safe: без импорта node:async_hooks его можно
 * держать в клиентском бандле (там impl === null и всё работает как раньше —
 * на модульных синглтонах).
 */

export interface SsrRequestScope {
  queryClient?: unknown;
  boundRouter?: unknown;
}

interface RequestScopeImpl {
  getStore: () => SsrRequestScope | undefined;
}

let impl: RequestScopeImpl | null = null;

/** Вызывается серверным входом (src/server.ts) один раз при старте. */
export const setRequestScopeImpl = (nextImpl: RequestScopeImpl): void => {
  impl = nextImpl;
};

/**
 * Контекст текущего SSR-запроса. undefined — клиент (или сервер без
 * установленного входа): вызывающий код падает обратно на модульный синглтон.
 */
export const getRequestScope = (): SsrRequestScope | undefined =>
  impl?.getStore();
